export default __webpack_public_path__ + "assets/homescreentutorialstep5figureSafari.png";